var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", [
            _c(
              "div",
              { staticStyle: { padding: "10px 25px" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.form, rules: _vm.rules }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "toWhere" } },
                      [
                        _c(
                          "el-select",
                          {
                            ref: "toWhere",
                            attrs: { placeholder: "请选择调拨方向" },
                            on: { change: _vm.handleToWhere },
                            model: {
                              value: _vm.form.toWhere,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "toWhere", $$v)
                              },
                              expression: "form.toWhere"
                            }
                          },
                          _vm._l(_vm.to_where_options, function(item, key) {
                            return _c("el-option", {
                              key: key,
                              attrs: { label: item, value: key }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.blp_radio_disabled
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "不良品类型:" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.blp_radio_disabled },
                                model: {
                                  value: _vm.form.blp_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "blp_type", $$v)
                                  },
                                  expression: "form.blp_type"
                                }
                              },
                              _vm._l(_vm.blp_type, function(item, key) {
                                return _c(
                                  "el-radio",
                                  { key: item, attrs: { label: key } },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.radio_disabled
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "次品等级:" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.radio_disabled },
                                model: {
                                  value: _vm.form.the_level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "the_level", $$v)
                                  },
                                  expression: "form.the_level"
                                }
                              },
                              _vm._l(_vm.the_level_options, function(
                                item,
                                key
                              ) {
                                return _c(
                                  "el-radio",
                                  { key: item, attrs: { label: key } },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.radio_disabled
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "问题分类:" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.radio_disabled },
                                model: {
                                  value: _vm.form.problem_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "problem_type", $$v)
                                  },
                                  expression: "form.problem_type"
                                }
                              },
                              _vm._l(_vm.problem_type_options, function(
                                item,
                                key
                              ) {
                                return _c(
                                  "el-radio",
                                  { key: item, attrs: { label: key } },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "qrCode" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c("el-input", {
                                  ref: "qrCode",
                                  attrs: {
                                    disabled: !(
                                      _vm.form.toWhere > 0 &&
                                      (_vm.form.blp_type > 0 ||
                                        (_vm.form.the_level > 0 &&
                                          _vm.form.problem_type > 0) ||
                                        _vm.form.toWhere == 1)
                                    ),
                                    placeholder: "请输入dbid(dbid=xxx)"
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.submit.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.qrCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "qrCode", $$v)
                                    },
                                    expression: "form.qrCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("PC调拨")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b9d65fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9d65fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PcTrans.vue
// module id = null
// module chunks = 